<template>
    <div class="layout__container">
        <div class="layout__width-80 layout__padding-clear">
            <div class="layout__padding-20px">

                <div class="text__align-center text__colour-white layout__margin__bottom-25px">
                    <div class="layout__padding-clear layout__width-80 layout__padding-40px-0 layout__border__bottom-light-teal-1px">
                        <h2 class="text__colour-teal">Switch Ordering Branch</h2>
                        <div class="layout__padding-20-0 text__size-18 text__colour-grey">Please select an alternative branch from the available options
                        </div>
                    </div>
                </div>
                <div class="layout__margin-20-0">
                    <div class="layout__width-60 layout__position-left">
                        <div>
                            <div class="layout__padding-20-0 layout__border__bottom">
                                <h3 class="text__colour-teal text__align-center layout__padding-10px-0">Available Branches</h3>
                            </div>
                            <el-table
                                    :data="available_branches.filter(data => !search || data.customerBranchName.toLowerCase().includes(search.toLowerCase()) || data.customerRef.toLowerCase().includes(search.toLowerCase()))"
                                    style="width: 100%"
                                    ref="singleTable"
                                    highlight-current-row
                                    border-bottom
                            :disabled="true">
                                <!--<el-table-column-->
                                        <!--type="selection">-->
                                <!--</el-table-column>-->
                                <!--<el-table-column>-->
                                    <!--<template slot-scope="props">-->
                                        <!--<el-radio-button v-model="checked" class="layout__border__none">Select</el-radio-button>-->
                                    <!--</template>-->
                                <!--</el-table-column>-->
                                <el-table-column
                                        label="Branch Name"
                                        prop="customerBranchName">
                                </el-table-column>
                                <el-table-column
                                        label="Branch Ref"
                                        prop="customerRef">
                                </el-table-column>
                                <el-table-column
                                        label="Branch Status"
                                        prop="customerStatus">
                                </el-table-column>
                                <el-table-column label="Select Branch">
                                    <template slot-scope="props">
                                        <div class="text__align-left">
                                            <el-button class="button-teal button__base layout__width-100px" :disabled="current_branch.ref === props.row.customerRef" v-on:click="handleCurrentChange(props.row)">Select</el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        align="right">
                                    <template slot="header" slot-scope="scope">
                                        <el-input
                                                v-model="search"
                                                size="medium"
                                                placeholder="Search"/>
                                    </template>
                                </el-table-column>
                            </el-table>


                            <!--<el-table-->
                                    <!--:data="available_branches.filter(data => !search || data.customerBranchName.toLowerCase().includes(search.toLowerCase()) || data.customerRef.toLowerCase().includes(search.toLowerCase()))"-->
                                    <!--style="width: 100%"-->
                                    <!--ref="singleTable"-->
                                    <!--highlight-current-row-->
                                    <!--@current-change="handleCurrentChange"-->
                                    <!--border-bottom>-->
                                <!--<el-table-column-->
                                        <!--label="Branch Name"-->
                                        <!--prop="customerBranchName">-->
                                <!--</el-table-column>-->
                                <!--<el-table-column-->
                                        <!--label="Branch Ref"-->
                                        <!--prop="customerRef">-->
                                <!--</el-table-column>-->
                                <!--<el-table-column-->
                                        <!--label="Branch Status"-->
                                        <!--prop="customerStatus">-->
                                <!--</el-table-column>-->
                                <!--<el-table-column align="center">-->
                                    <!--<template slot="header" slot-scope="scope">-->
                                        <!--<el-input-->
                                                <!--v-model="search"-->
                                                <!--size="mini"-->
                                                <!--placeholder="Type to search"/>-->
                                    <!--</template>-->
                                <!--</el-table-column>-->
                            <!--</el-table>-->
                        </div>






                    </div>
                    <div class="layout__width-30 layout__position-left text__align-center layout__margin-0-20">
                        <!--<h4>You are currently logged in as Branch: </h4>-->
                        <p class="layout__padding-20-0">Your active orders in your basket have been saved to branch: {{this.current_branch.branchName}} ({{this.current_branch.ref}})</p>
                        <p class="layout__padding-20-0">This basket will <span class="text__colour-red">NOT</span> be transferred upon switching branches, but will be available again when you switch back to this branch.</p>

                        <div v-show="selected_branch !== ''" class="">
                            <h3 class="layout__padding-20-0">Please confirm you would like to switch the branch to:</h3>
                            <div class="text__colour-red">{{selected_branch.customerBranchName}} ({{selected_branch.customerRef}})</div>


                            <div class="layout__display-block">
                                <el-button
                                        class="layout__margin-20-0 layout__padding-0-20 button-red button__base"
                                        v-on:click="switchBranch" :disabled="selected_branch === ''">
                                    Yes, Switch my Branch
                                </el-button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Vue from 'vue';
    import Element from 'element-ui';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import Axios from 'axios';
    import Router from '../../router';
    import EventBus from '../../EventBus.js';
    import {Loading} from 'element-ui';

    Vue.use(Element);

    export default {
        name: "switchbranch",
        mixins: [axios, dataFormatter],
        data() {
            return {
                available_branches: [],
                selected_branch: '',
                current_branch: '',
                search: '',
                checked: ''
            }
        },
        computed: {
        },
        created() {

            this.current_branch = JSON.parse(this.returnCookie('_customer'))

            const url = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Customer/GetCustomerMemberships?userId=` + window.sessionStorage.getItem('_userId')

            Axios.get(url, this.returnHeaderUsingToken())
                .then(response => {
                    console.log(response)
                    this.available_branches = response.data.result



                    // response.data.result.forEach(branch => {
                    //     if (branch.customerRef !== this.current_branch) {
                    //         this.available_branches.push(branch)
                    //     }
                    // })
                })
        },
        mounted() {
        },
        methods: {
            switchBranch() {

                // switch
                // wipe on success
                // call get login context
                // do it all again
                let loadingInstance = Loading.service({
                    fullscreen: true
                });

                const getSwitchedToken = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/TokenAuth/UpdateSessionAsCustomer?customerRef=` + this.selected_branch.customerRef

                console.log('getSwitchedToken', getSwitchedToken)

                Axios.put(getSwitchedToken, {}, this.returnHeaderUsingToken())
                    .then(response => {

                        console.log('Update session token ', response)


                        const accessToken = response.data.result.accessToken;
                        const getCurrentLoginContext = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Session/GetCurrentLoginContext`

                        console.log('getLoginContext', getCurrentLoginContext)

                        Axios.get(getCurrentLoginContext, this.returnHeaderUsingParameter(accessToken))
                            .then(response => {

                                console.log(response.data.result.customer)

                                window.sessionStorage.clear();

                                window.sessionStorage.setItem("_membershipCount", response.data.result.session.membershipCount)

                                const basketTotals = {
                                    photofixr: 0,
                                    instantPrint: 0
                                }

                                this.$store.dispatch("incrementPhotofixrTotal", basketTotals)

                                this.$store.dispatch("incrementPhotofixrTotal", basketTotals)
                                EventBus.$emit('activeOrders', null, null, null)

                                this.persistUserSessionUsingParameter(accessToken, response)

                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });


                                Router.push({
                                    name: '/account/switch-branch/confirmation'
                                });


                            })
                            .catch(error => {

                                console.log(error)
                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });


                                if (error.response.status === 500) {
                                    document.getElementById('error').style.display = 'block';
                                }
                                // this.$nextTick(() => { // Loading should be closed asynchronously
                                //     loadingInstance.close();
                                // });
                                event.stopPropagation();


                            });

                    });

            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChange(val) {
                console.log(val)
                this.selected_branch = val;
            },
            isCurrentBranch(val) {
                console.log(val)
            }
        }

    };
</script>